require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.array.sort");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.array.find");

!function (e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : ("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).littlefoot = e();
}(function () {
  var e = function e(_e2) {
    return _e2 && _e2.__esModule ? _e2 : {
      default: _e2
    };
  },
      i = {};

  Object.defineProperty(i, "__esModule", {
    value: !0
  }), i.createCore = function (o, i) {
    var a = (r = o, u = i, function (e) {
      var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : u.activateDelay,
          n = u.activateCallback;
      e.isChanging() || (e.startChanging(), e.activate(n), r.footnotes().forEach(function (e) {
        e.reposition(), e.resize();
      }), setTimeout(function () {
        e.ready(), e.stopChanging();
      }, t));
    }),
        c = (n = i, function (e) {
      var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : n.dismissDelay;
      e.isChanging() || (e.startChanging(), e.dismiss(), setTimeout(function () {
        e.remove(), e.stopChanging();
      }, t));
    }),
        n,
        r,
        u;
    return {
      activate: a,
      dismiss: c,
      findById: function findById(t) {
        return o.footnotes().find(function (e) {
          return e.getId() === t;
        });
      },
      unmount: o.unmount,
      dismissAll: function dismissAll() {
        var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : i.dismissDelay;
        o.footnotes().forEach(function (e) {
          return c(e, t);
        });
      },
      repositionAll: function repositionAll() {
        o.footnotes().forEach(function (e) {
          return e.reposition();
        });
      },
      resizeAll: function resizeAll() {
        o.footnotes().forEach(function (e) {
          return e.resize();
        });
      },
      toggle: function toggle(t) {
        var e = i.allowMultiple;
        t.isActive() ? c(t) : (e || o.footnotes().filter(function (e) {
          return e.getId() !== t.getId();
        }).forEach(c), a(t));
      },
      hover: function hover(t) {
        var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : i.hoverDelay,
            n = i.activateOnHover,
            r = i.allowMultiple;
        t.startHovering(), n && !t.isActive() && (r || o.footnotes().filter(function (e) {
          return e.getId() !== t.getId();
        }).forEach(c), a(t, e));
      },
      unhover: function unhover(e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : i.hoverDelay,
            n = i.dismissOnUnhover;
        e.stopHovering(), n && setTimeout(function () {
          o.footnotes().some(function (e) {
            return e.isHovered();
          }) || o.footnotes().forEach(c);
        }, t);
      }
    };
  };
  var c = {};
  Object.defineProperty(c, "__esModule", {
    value: !0
  }), c.getStyle = function (e, t) {
    var n = (e.ownerDocument && e.ownerDocument.defaultView || window).getComputedStyle(e);
    return n.getPropertyValue(t) || n[t];
  };
  var r = {};

  function f(e) {
    return e ? c.getStyle(e, "fontSize") || f(e.parentElement) : c.getStyle(window.document.documentElement, "fontSize");
  }

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.pixels = function e(t, n) {
    var r = n && n.ownerDocument && n.ownerDocument.defaultView || window,
        o = r.document.documentElement || r.document.body,
        i = (u = (c = t) || "0", l = parseFloat(u), s = u.match(/[\d-.]+(\w+)$/), [l, (s && 1 < s.length ? s[1] : "").toLowerCase()]),
        a = i[0],
        c,
        u,
        l,
        s;

    switch (i[1]) {
      case "rem":
        return a * e(f(window.document.documentElement));

      case "em":
        return a * e(f(n), n && n.parentElement);

      case "in":
        return 96 * a;

      case "q":
        return 96 * a / 25.4 / 4;

      case "mm":
        return 96 * a / 25.4;

      case "cm":
        return 96 * a * 10 / 25.4;

      case "pt":
        return 96 * a / 72;

      case "pc":
        return 96 * a / 6;

      case "vh":
        return (a * r.innerHeight || o.clientWidth) / 100;

      case "vw":
        return (a * r.innerWidth || o.clientHeight) / 100;

      case "vmin":
        return a * Math.min(r.innerWidth || o.clientWidth, r.innerHeight || o.clientHeight) / 100;

      case "vmax":
        return a * Math.max(r.innerWidth || o.clientWidth, r.innerHeight || o.clientHeight) / 100;

      default:
        return a;
    }
  };
  var o = {};
  (function (e) {
    var b = "Expected a function",
        i = NaN,
        a = "[object Symbol]",
        c = /^\s+|\s+$/g,
        u = /^[-+]0x[0-9a-f]+$/i,
        l = /^0b[01]+$/i,
        s = /^0o[0-7]+$/i,
        f = parseInt,
        t = "object" == typeof e && e && e.Object === Object && e,
        n = "object" == typeof self && self && self.Object === Object && self,
        r = t || n || Function("return this")(),
        d = Object.prototype.toString,
        m = Math.max,
        j = Math.min,
        w = function w() {
      return r.Date.now();
    };

    function O(e) {
      var t = typeof e;
      return !!e && ("object" == t || "function" == t);
    }

    function _(e) {
      if ("number" == typeof e) return e;
      if ("symbol" == typeof (t = e) || (n = t) && "object" == typeof n && d.call(t) == a) return i;
      var t, n;

      if (O(e)) {
        var r = "function" == typeof e.valueOf ? e.valueOf() : e;
        e = O(r) ? r + "" : r;
      }

      if ("string" != typeof e) return 0 === e ? e : +e;
      e = e.replace(c, "");
      var o = l.test(e);
      return o || s.test(e) ? f(e.slice(2), o ? 2 : 8) : u.test(e) ? i : +e;
    }

    o = function o(e, t, n) {
      var r = !0,
          o = !0;
      if ("function" != typeof e) throw new TypeError(b);
      return O(n) && (r = "leading" in n ? !!n.leading : r, o = "trailing" in n ? !!n.trailing : o), function (r, o, e) {
        var i,
            a,
            c,
            u,
            l,
            s,
            f = 0,
            d = !1,
            p = !1,
            t = !0;
        if ("function" != typeof r) throw new TypeError(b);

        function v(e) {
          var t = i,
              n = a;
          return i = a = void 0, f = e, u = r.apply(n, t);
        }

        function h(e) {
          var t = e - s;
          return void 0 === s || o <= t || t < 0 || p && c <= e - f;
        }

        function g() {
          var e = w(),
              t,
              n;
          if (h(e)) return y(e);
          l = setTimeout(g, (n = o - ((t = e) - s), p ? j(n, c - (t - f)) : n));
        }

        function y(e) {
          return l = void 0, t && i ? v(e) : (i = a = void 0, u);
        }

        function n() {
          var e = w(),
              t = h(e),
              n;

          if (i = arguments, a = this, s = e, t) {
            if (void 0 === l) return f = n = s, l = setTimeout(g, o), d ? v(n) : u;
            if (p) return l = setTimeout(g, o), v(s);
          }

          return void 0 === l && (l = setTimeout(g, o)), u;
        }

        return o = _(o) || 0, O(e) && (d = !!e.leading, c = (p = "maxWait" in e) ? m(_(e.maxWait) || 0, o) : c, t = "trailing" in e ? !!e.trailing : t), n.cancel = function () {
          void 0 !== l && clearTimeout(l), i = s = a = l = void (f = 0);
        }, n.flush = function () {
          return void 0 === l ? u : y(w());
        }, n;
      }(e, t, {
        leading: r,
        maxWait: t,
        trailing: o
      });
    };
  }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
  var t,
      n = {};
  t = function t() {
    "use strict";

    function e() {
      if (!(this instanceof e)) return new e();
      this.size = 0, this.uid = 0, this.selectors = [], this.indexes = Object.create(this.indexes), this.activeIndexes = [];
    }

    var t = window.document.documentElement,
        n = t.matches || t.webkitMatchesSelector || t.mozMatchesSelector || t.oMatchesSelector || t.msMatchesSelector;
    e.prototype.matchesSelector = function (e, t) {
      return n.call(e, t);
    }, e.prototype.querySelectorAll = function (e, t) {
      return t.querySelectorAll(e);
    };
    var r = /^#((?:[\w\u00c0-\uFFFF\-]|\\.)+)/g;
    (e.prototype.indexes = []).push({
      name: "ID",
      selector: function selector(e) {
        var t;
        if (t = e.match(r)) return t[0].slice(1);
      },
      element: function element(e) {
        if (e.id) return [e.id];
      }
    });
    var o = /^\.((?:[\w\u00c0-\uFFFF\-]|\\.)+)/g;
    e.prototype.indexes.push({
      name: "CLASS",
      selector: function selector(e) {
        var t;
        if (t = e.match(o)) return t[0].slice(1);
      },
      element: function element(e) {
        var t = e.className;

        if (t) {
          if ("string" == typeof t) return t.split(/\s/);
          if ("object" == typeof t && "baseVal" in t) return t.baseVal.split(/\s/);
        }
      }
    });
    var d,
        i = /^((?:[\w\u00c0-\uFFFF\-]|\\.)+)/g;

    function a() {
      this.map = {};
    }

    e.prototype.indexes.push({
      name: "TAG",
      selector: function selector(e) {
        var t;
        if (t = e.match(i)) return t[0].toUpperCase();
      },
      element: function element(e) {
        return [e.nodeName.toUpperCase()];
      }
    }), e.prototype.indexes.default = {
      name: "UNIVERSAL",
      selector: function selector() {
        return !0;
      },
      element: function element() {
        return [!0];
      }
    }, d = "function" == typeof window.Map ? window.Map : (a.prototype.get = function (e) {
      return this.map[e + " "];
    }, a.prototype.set = function (e, t) {
      this.map[e + " "] = t;
    }, a);
    var f = /((?:\((?:\([^()]+\)|[^()]+)+\)|\[(?:\[[^\[\]]*\]|['"][^'"]*['"]|[^\[\]'"]+)+\]|\\.|[^ >+~,(\[\\]+)+|[>+~])(\s*,\s*)?((?:.|\r|\n)*)/g;

    function p(e, t) {
      var n,
          r,
          o,
          i,
          a,
          c,
          u = (e = e.slice(0).concat(e.default)).length,
          l = t,
          s = [];

      do {
        if (f.exec(""), (o = f.exec(l)) && (l = o[3], o[2] || !l)) for (n = 0; n < u; n++) {
          if (a = (c = e[n]).selector(o[1])) {
            for (r = s.length, i = !1; r--;) {
              if (s[r].index === c && s[r].key === a) {
                i = !0;
                break;
              }
            }

            i || s.push({
              index: c,
              key: a
            });
            break;
          }
        }
      } while (o);

      return s;
    }

    function v(e, t) {
      var n, r, o;

      for (n = 0, r = e.length; n < r; n++) {
        if (o = e[n], t.isPrototypeOf(o)) return o;
      }
    }

    function h(e, t) {
      return e.id - t.id;
    }

    return e.prototype.logDefaultIndexUsed = function () {}, e.prototype.add = function (e, t) {
      var n,
          r,
          o,
          i,
          a,
          c,
          u,
          l,
          s = this.activeIndexes,
          f = this.selectors;

      if ("string" == typeof e) {
        for (n = {
          id: this.uid++,
          selector: e,
          data: t
        }, u = p(this.indexes, e), r = 0; r < u.length; r++) {
          i = (l = u[r]).key, (a = v(s, o = l.index)) || ((a = Object.create(o)).map = new d(), s.push(a)), o === this.indexes.default && this.logDefaultIndexUsed(n), (c = a.map.get(i)) || (c = [], a.map.set(i, c)), c.push(n);
        }

        this.size++, f.push(e);
      }
    }, e.prototype.remove = function (e, t) {
      if ("string" == typeof e) {
        var n,
            r,
            o,
            i,
            a,
            c,
            u,
            l,
            s = this.activeIndexes,
            f = {},
            d = 1 === arguments.length;

        for (n = p(this.indexes, e), o = 0; o < n.length; o++) {
          for (r = n[o], i = s.length; i--;) {
            if (c = s[i], r.index.isPrototypeOf(c)) {
              if (u = c.map.get(r.key)) for (a = u.length; a--;) {
                (l = u[a]).selector !== e || !d && l.data !== t || (u.splice(a, 1), f[l.id] = !0);
              }
              break;
            }
          }
        }

        this.size -= Object.keys(f).length;
      }
    }, e.prototype.queryAll = function (e) {
      if (!this.selectors.length) return [];
      var t,
          n,
          r,
          o,
          i,
          a,
          c,
          u,
          l = {},
          s = [],
          f = this.querySelectorAll(this.selectors.join(", "), e);

      for (t = 0, r = f.length; t < r; t++) {
        for (i = f[t], n = 0, o = (a = this.matches(i)).length; n < o; n++) {
          l[(u = a[n]).id] ? c = l[u.id] : (c = {
            id: u.id,
            selector: u.selector,
            data: u.data,
            elements: []
          }, l[u.id] = c, s.push(c)), c.elements.push(i);
        }
      }

      return s.sort(h);
    }, e.prototype.matches = function (e) {
      if (!e) return [];
      var t,
          n,
          r,
          o,
          i,
          a,
          c,
          u,
          l,
          s,
          f,
          d = this.activeIndexes,
          p = {},
          v = [];

      for (t = 0, o = d.length; t < o; t++) {
        if (u = (c = d[t]).element(e)) for (n = 0, i = u.length; n < i; n++) {
          if (l = c.map.get(u[n])) for (r = 0, a = l.length; r < a; r++) {
            !p[f = (s = l[r]).id] && this.matchesSelector(e, s.selector) && (p[f] = !0, v.push(s));
          }
        }
      }

      return v.sort(h);
    }, e;
  }, "object" == typeof n ? n = t() : this.SelectorSet = t();
  var a,
      u,
      b = {
    exports: {}
  };
  a = this, u = function u(e, a) {
    "use strict";

    a = a && a.hasOwnProperty("default") ? a.default : a;
    var u = {},
        l = {},
        s = new WeakMap(),
        f = new WeakMap(),
        d = new WeakMap(),
        n = Object.getOwnPropertyDescriptor(Event.prototype, "currentTarget");

    function p(e, t, n) {
      var r = e[t];
      return e[t] = function () {
        return n.apply(e, arguments), r.apply(e, arguments);
      }, e;
    }

    function v() {
      s.set(this, !0);
    }

    function h() {
      s.set(this, !0), f.set(this, !0);
    }

    function g() {
      return d.get(this) || null;
    }

    function y(e, t) {
      n && Object.defineProperty(e, "currentTarget", {
        configurable: !0,
        enumerable: !0,
        get: t || n.get
      });
    }

    function c(e) {
      var t = (1 === e.eventPhase ? l : u)[e.type];

      if (t) {
        var n = function (e, t, n) {
          var r = [],
              o = t;

          do {
            if (1 !== o.nodeType) break;
            var i = e.matches(o);

            if (i.length) {
              var a = {
                node: o,
                observers: i
              };
              n ? r.unshift(a) : r.push(a);
            }
          } while (o = o.parentElement);

          return r;
        }(t, e.target, 1 === e.eventPhase);

        if (n.length) {
          p(e, "stopPropagation", v), p(e, "stopImmediatePropagation", h), y(e, g);

          for (var r = 0, o = n.length; r < o && !s.get(e); r++) {
            var i = n[r];
            d.set(e, i.node);

            for (var a = 0, c = i.observers.length; a < c && !f.get(e); a++) {
              i.observers[a].data.call(i.node, e);
            }
          }

          d.delete(e), y(e);
        }
      }
    }

    e.off = function (e, t, n) {
      var r = !!(3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {}).capture,
          o = r ? l : u,
          i = o[e];
      i && (i.remove(t, n), i.size || (delete o[e], document.removeEventListener(e, c, r)));
    }, e.on = function (e, t, n) {
      var r = !!(3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {}).capture,
          o = r ? l : u,
          i = o[e];
      i || (i = new a(), o[e] = i, document.addEventListener(e, c, r)), i.add(t, n);
    }, Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, "object" == typeof b.exports ? u(b.exports, n) : u((a = a || self)["delegated-events"] = {}, a.SelectorSet), b = b.exports;
  var j = {};
  Object.defineProperty(j, "__esModule", {
    value: !0
  }), j.bindContentScrollHandler = function (e) {
    var t = (0, m.default)(s);
    e.addEventListener("mousewheel", t), e.addEventListener("wheel", t);
  }, j.addEventListeners = function (e) {
    var t,
        n = e.dismissAll,
        r = e.findById,
        o = e.hover,
        i = e.repositionAll,
        a = e.resizeAll,
        c = e.toggle,
        u = e.unhover,
        l = (h = r, g = c, y = n, function (e) {
      var t,
          n = (t = e.target.closest("[data-footnote-button]")) && t.dataset.footnoteId,
          r = n && h(n);
      r ? g(r) : O(e.target) || y();
    }),
        s = (t = n, function (e) {
      return 27 === e.keyCode && t();
    }),
        f = (0, m.default)(i),
        d = (0, m.default)(a),
        p = _(r, o),
        v = _(r, u),
        h,
        g,
        y;

    return document.addEventListener("touchend", l), document.addEventListener("click", l), document.addEventListener("keyup", s), document.addEventListener("gestureend", f), window.addEventListener("scroll", f), window.addEventListener("resize", d), (0, b.on)("mouseover", w, p), (0, b.on)("mouseout", w, v), function () {
      document.removeEventListener("touchend", l), document.removeEventListener("click", l), document.removeEventListener("keyup", s), document.removeEventListener("gestureend", f), window.removeEventListener("scroll", f), window.removeEventListener("resize", d), (0, b.off)("mouseover", w, p), (0, b.off)("mouseout", w, v);
    };
  }, j.FOOTNOTE_SELECTOR = void 0;
  var m = e(o),
      w = "[data-footnote-id]";
  j.FOOTNOTE_SELECTOR = w;
  var l = "is-fully-scrolled";

  function O(e) {
    return e.closest("[data-footnote-popover]");
  }

  function _(o, i) {
    return function (e) {
      e.preventDefault();
      var t,
          n = (t = e.target.closest(w)) && t.dataset.footnoteId,
          r = n && o(n);
      r && i(r);
    };
  }

  function s(e) {
    var t = e.currentTarget,
        n = -e.deltaY,
        r = t.clientHeight,
        o = O(t);
    if (o && n <= 0 && n < r + t.scrollTop - t.scrollHeight) return o.classList.add(l), t.scrollTop = t.scrollHeight, void e.preventDefault();
    o && 0 < n && (o.classList.remove(l), t.scrollTop < n && (t.scrollTop = 0, e.preventDefault()));
  }

  var d = {};
  Object.defineProperty(d, "__esModule", {
    value: !0
  }), d.getAvailableRoom = function (e) {
    var t = parseFloat((0, c.getStyle)(e, "marginLeft")),
        n = e.offsetWidth - t,
        r = e.offsetHeight,
        o = e.getBoundingClientRect(),
        i = o.left + n / 2,
        a = o.top + r / 2;
    return {
      top: a,
      bottom: window.innerHeight - a,
      leftRelative: i / window.innerWidth
    };
  }, d.getAvailableHeight = function (e, t) {
    var n = y(e, t),
        r = parseInt((0, c.getStyle)(e, "marginTop"), 10);
    return t[n ? g : h] - r - 15;
  }, d.repositionPopover = function (e, t) {
    var n = y(e, t),
        r = e.dataset.footnotePosition,
        o = n ? g : h;
    r !== o && (e.dataset.footnotePosition = o, e.classList.remove("".concat(v).concat(r)), e.classList.add("".concat(v).concat(o)), e.style.transformOrigin = "".concat(100 * t.leftRelative, "% ").concat(n ? "100%" : "0"));
  }, d.repositionTooltip = function (e) {
    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : .5,
        n = e.querySelector("." + p);
    n && (n.style.left = 100 * t + "%");
  }, d.CLASS_WRAPPER = d.CLASS_TOOLTIP = d.CLASS_CONTENT = void 0, d.CLASS_CONTENT = "littlefoot-footnote__content";
  var p = "littlefoot-footnote__tooltip";
  d.CLASS_TOOLTIP = p, d.CLASS_WRAPPER = "littlefoot-footnote__wrapper";
  var v = "is-positioned-",
      h = "bottom",
      g = "top";

  function y(e, t) {
    var n = 2 * parseInt((0, c.getStyle)(e, "marginTop"), 10) + e.offsetHeight;
    return t.bottom < n && t.bottom < t.top;
  }

  var S = {};
  Object.defineProperty(S, "__esModule", {
    value: !0
  }), S.createFootnote = function (i) {
    return {
      getId: function getId() {
        return i.id;
      },
      activate: function activate(e) {
        i.button.blur(), i.button.setAttribute("aria-expanded", "true"), i.button.classList.add(A), i.button.insertAdjacentHTML("afterend", i.content), i.popover = i.button.nextElementSibling, i.popover.dataset.footnotePopover = "", i.popover.dataset.footnoteId = i.id;
        var t = L(i.popover);
        i.popover.style.maxWidth = "".concat(document.body.clientWidth, "px"), (0, j.bindContentScrollHandler)(t);
        var n = (0, c.getStyle)(t, "maxHeight");
        i.maxHeight = Math.round((0, r.pixels)(n, t)), "function" == typeof e && e(i.popover, i.button);
      },
      dismiss: function dismiss() {
        i.button.blur(), i.button.setAttribute("aria-expanded", "false"), i.button.classList.remove(A);
      },
      isActive: function isActive() {
        return i.button.classList.contains(A);
      },
      isChanging: function isChanging() {
        return i.button.classList.contains(x);
      },
      isHovered: function isHovered() {
        return i.isHovered;
      },
      ready: function ready() {
        i.popover && i.popover.classList.add(A);
      },
      remove: function remove() {
        i.popover && (i.popover.parentNode.removeChild(i.popover), delete i.popover);
      },
      reposition: function reposition() {
        if (i.popover) {
          var e = (0, d.getAvailableRoom)(i.button),
              t = L(i.popover),
              n = Math.min(i.maxHeight, (0, d.getAvailableHeight)(i.popover, e));
          t.style.maxHeight = n + "px", (0, d.repositionPopover)(i.popover, e), i.popover.offsetHeight <= t.scrollHeight && i.popover.classList.add(E);
        }
      },
      resize: function resize() {
        if (i.popover) {
          var e = (0, d.getAvailableRoom)(i.button),
              t = L(i.popover).offsetWidth,
              n = parseInt((0, c.getStyle)(i.button, "marginLeft"), 10),
              r = -e.leftRelative * t + n + i.button.offsetWidth / 2,
              o = i.popover.querySelector("." + d.CLASS_WRAPPER);
          i.popover.style.left = r + "px", o && (o.style.maxWidth = t + "px"), (0, d.repositionTooltip)(i.popover, e.leftRelative);
        }
      },
      startChanging: function startChanging() {
        i.button.classList.add(x);
      },
      stopChanging: function stopChanging() {
        i.button.classList.remove(x);
      },
      startHovering: function startHovering() {
        i.isHovered = !0;
      },
      stopHovering: function stopHovering() {
        i.isHovered = !1;
      },
      unmount: function unmount() {
        i.host.parentNode.removeChild(i.host);
      }
    };
  };
  var A = "is-active",
      x = "is-changing",
      E = "is-scrollable";

  function L(e) {
    return e.querySelector("." + d.CLASS_CONTENT);
  }

  var De = /<%=([\s\S]+?)%>/g,
      Re = {};
  (function (e) {
    var t,
        a = 1 / 0,
        c = "[object Null]",
        u = "[object Symbol]",
        l = "[object Undefined]",
        n = /[&<>"']/g,
        r = RegExp(n.source),
        o = "object" == typeof e && e && e.Object === Object && e,
        i = "object" == typeof self && self && self.Object === Object && self,
        s = o || i || Function("return this")(),
        f = (t = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, function (e) {
      return null == t ? void 0 : t[e];
    }),
        d = Object.prototype,
        p = d.hasOwnProperty,
        v = d.toString,
        h = s.Symbol,
        g = h ? h.toStringTag : void 0,
        y = h ? h.prototype : void 0,
        b = y ? y.toString : void 0,
        m = {
      escape: /<%-([\s\S]+?)%>/g,
      evaluate: /<%([\s\S]+?)%>/g,
      interpolate: De,
      variable: "",
      imports: {
        _: {
          escape: function escape(e) {
            return (e = null == (t = e) ? "" : j(t)) && r.test(e) ? e.replace(n, f) : e;
            var t;
          }
        }
      }
    };

    function j(e) {
      if ("string" == typeof e) return e;
      if (w(e)) return function (e, t) {
        for (var n = -1, r = null == e ? 0 : e.length, o = Array(r); ++n < r;) {
          o[n] = t(e[n], n, e);
        }

        return o;
      }(e, j) + "";
      if ("symbol" == typeof (t = e) || null != (o = t) && "object" == typeof o && (null == (n = t) ? void 0 === n ? l : c : g && g in Object(n) ? function (e) {
        var t = p.call(e, g),
            n = e[g];

        try {
          var r = !(e[g] = void 0);
        } catch (e) {}

        var o = v.call(e);
        return r && (t ? e[g] = n : delete e[g]), o;
      }(n) : (r = n, v.call(r))) == u) return b ? b.call(e) : "";
      var t,
          n,
          r,
          o,
          i = e + "";
      return "0" == i && 1 / e == -a ? "-0" : i;
    }

    var w = Array.isArray;
    Re = m;
  }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
  var We = {
    exports: {}
  };
  (function (e) {
    var r = 1 / 0,
        o = 9007199254740991,
        t = "[object Arguments]",
        n = "[object AsyncFunction]",
        i = "[object DOMException]",
        a = "[object Error]",
        c = "[object Function]",
        u = "[object GeneratorFunction]",
        l = "[object Null]",
        s = "[object Object]",
        f = "[object Proxy]",
        d = "[object Symbol]",
        p = "[object Undefined]",
        m = /\b__p \+= '';/g,
        j = /\b(__p \+=) '' \+/g,
        w = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
        O = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
        v = /^\[object .+?Constructor\]$/,
        h = /^(?:0|[1-9]\d*)$/,
        _ = /($^)/,
        S = /['\n\r\u2028\u2029\\]/g,
        g = {};
    g["[object Float32Array]"] = g["[object Float64Array]"] = g["[object Int8Array]"] = g["[object Int16Array]"] = g["[object Int32Array]"] = g["[object Uint8Array]"] = g["[object Uint8ClampedArray]"] = g["[object Uint16Array]"] = g["[object Uint32Array]"] = !0, g[t] = g["[object Array]"] = g["[object ArrayBuffer]"] = g["[object Boolean]"] = g["[object DataView]"] = g["[object Date]"] = g[a] = g[c] = g["[object Map]"] = g["[object Number]"] = g[s] = g["[object RegExp]"] = g["[object Set]"] = g["[object String]"] = g["[object WeakMap]"] = !1;

    var y = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    },
        b = "object" == typeof e && e && e.Object === Object && e,
        A = "object" == typeof self && self && self.Object === Object && self,
        x = b || A || Function("return this")(),
        E = "object" == typeof We.exports && We.exports && !We.exports.nodeType && We.exports,
        L = E && We && !We.nodeType && We,
        T = L && L.exports === E,
        P = T && b.process,
        C = function () {
      try {
        return L && L.require && L.require("util").types || P && P.binding && P.binding("util");
      } catch (e) {}
    }(),
        H = C && C.isTypedArray;

    function I(e, t, n) {
      switch (n.length) {
        case 0:
          return e.call(t);

        case 1:
          return e.call(t, n[0]);

        case 2:
          return e.call(t, n[0], n[1]);

        case 3:
          return e.call(t, n[0], n[1], n[2]);
      }

      return e.apply(t, n);
    }

    function M(e, t) {
      for (var n = -1, r = null == e ? 0 : e.length, o = Array(r); ++n < r;) {
        o[n] = t(e[n], n, e);
      }

      return o;
    }

    function F(e) {
      return "\\" + y[e];
    }

    function D(t, n) {
      return function (e) {
        return t(n(e));
      };
    }

    var R,
        W = Function.prototype,
        k = Object.prototype,
        N = x["__core-js_shared__"],
        $ = W.toString,
        U = k.hasOwnProperty,
        q = (R = /[^.]+$/.exec(N && N.keys && N.keys.IE_PROTO || "")) ? "Symbol(src)_1." + R : "",
        z = k.toString,
        B = $.call(Object),
        V = RegExp("^" + $.call(U).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
        G = T ? x.Buffer : void 0,
        Y = x.Symbol,
        J = D(Object.getPrototypeOf, Object),
        K = k.propertyIsEnumerable,
        Q = Y ? Y.toStringTag : void 0,
        X = function () {
      try {
        var e = (r = Object, !Le(t = i = null == r ? void 0 : r.defineProperty) || q && q in (n = t) || !(xe(t) ? V : v).test(function (e) {
          if (null != e) {
            try {
              return $.call(e);
            } catch (e) {}

            try {
              return e + "";
            } catch (e) {}
          }

          return "";
        }(t)) ? void 0 : i);
        return e({}, "", {}), e;
      } catch (e) {}

      var t, n, r, o, i;
    }(),
        Z = G ? G.isBuffer : void 0,
        ee = D(Object.keys, Object),
        te = Math.max,
        ne = Date.now,
        re = Y ? Y.prototype : void 0,
        oe = re ? re.toString : void 0;

    function ie(e, t) {
      var n = Oe(e),
          r = !n && we(e),
          o = !n && !r && Se(e),
          i = !n && !r && !o && Ce(e),
          a = n || r || o || i,
          c = a ? function (e, t) {
        for (var n = -1, r = Array(e); ++n < e;) {
          r[n] = t(n);
        }

        return r;
      }(e.length, String) : [],
          u = c.length;

      for (var l in e) {
        !t && !U.call(e, l) || a && ("length" == l || o && ("offset" == l || "parent" == l) || i && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || pe(l, u)) || c.push(l);
      }

      return c;
    }

    function ae(e, t, n) {
      var r = e[t];
      U.call(e, t) && je(r, n) && (void 0 !== n || t in e) || ce(e, t, n);
    }

    function ce(e, t, n) {
      "__proto__" == t && X ? X(e, t, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      }) : e[t] = n;
    }

    function ue(e) {
      return null == e ? void 0 === e ? p : l : Q && Q in Object(e) ? function (e) {
        var t = U.call(e, Q),
            n = e[Q];

        try {
          var r = !(e[Q] = void 0);
        } catch (e) {}

        var o = z.call(e);
        return r && (t ? e[Q] = n : delete e[Q]), o;
      }(e) : (t = e, z.call(t));
      var t;
    }

    function le(e) {
      return Te(e) && ue(e) == t;
    }

    function se(e, t) {
      return me((i = e, c = Fe, a = te(void 0 === (a = t) ? i.length - 1 : a, 0), function () {
        for (var e = arguments, t = -1, n = te(e.length - a, 0), r = Array(n); ++t < n;) {
          r[t] = e[a + t];
        }

        t = -1;

        for (var o = Array(a + 1); ++t < a;) {
          o[t] = e[t];
        }

        return o[a] = c(r), I(i, this, o);
      }), e + "");
      var i, a, c;
    }

    function fe(e) {
      if ("string" == typeof e) return e;
      if (Oe(e)) return M(e, fe) + "";
      if ("symbol" == typeof (t = e) || Te(t) && ue(t) == d) return oe ? oe.call(e) : "";
      var t,
          n = e + "";
      return "0" == n && 1 / e == -r ? "-0" : n;
    }

    function de(e, t, n, r) {
      return void 0 === e || je(e, k[n]) && !U.call(r, n) ? t : e;
    }

    function pe(e, t) {
      var n = typeof e;
      return !!(t = null == t ? o : t) && ("number" == n || "symbol" != n && h.test(e)) && -1 < e && e % 1 == 0 && e < t;
    }

    function ve(e, t, n) {
      if (!Le(n)) return !1;
      var r = typeof t;
      return !!("number" == r ? _e(n) && pe(t, n.length) : "string" == r && t in n) && je(n[t], e);
    }

    function he(e) {
      var t = e && e.constructor;
      return e === ("function" == typeof t && t.prototype || k);
    }

    var ge,
        ye,
        be,
        me = (ge = X ? function (e, t) {
      return X(e, "toString", {
        configurable: !0,
        enumerable: !1,
        value: (n = t, function () {
          return n;
        }),
        writable: !0
      });
      var n;
    } : Fe, be = ye = 0, function () {
      var e = ne(),
          t = 16 - (e - be);

      if (be = e, 0 < t) {
        if (800 <= ++ye) return arguments[0];
      } else ye = 0;

      return ge.apply(void 0, arguments);
    });

    function je(e, t) {
      return e === t || e != e && t != t;
    }

    var we = le(function () {
      return arguments;
    }()) ? le : function (e) {
      return Te(e) && U.call(e, "callee") && !K.call(e, "callee");
    },
        Oe = Array.isArray;

    function _e(e) {
      return null != e && Ee(e.length) && !xe(e);
    }

    var Se = Z || function () {
      return !1;
    };

    function Ae(e) {
      if (!Te(e)) return !1;
      var t = ue(e);
      return t == a || t == i || "string" == typeof e.message && "string" == typeof e.name && !function (e) {
        if (!Te(e) || ue(e) != s) return !1;
        var t = J(e);
        if (null === t) return !0;
        var n = U.call(t, "constructor") && t.constructor;
        return "function" == typeof n && n instanceof n && $.call(n) == B;
      }(e);
    }

    function xe(e) {
      if (!Le(e)) return !1;
      var t = ue(e);
      return t == c || t == u || t == n || t == f;
    }

    function Ee(e) {
      return "number" == typeof e && -1 < e && e % 1 == 0 && e <= o;
    }

    function Le(e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    }

    function Te(e) {
      return null != e && "object" == typeof e;
    }

    var Pe,
        Ce = H ? (Ie = H, function (e) {
      return Ie(e);
    }) : function (e) {
      return Te(e) && Ee(e.length) && !!g[ue(e)];
    },
        He = (Pe = function Pe(e, t, n, r) {
      var o;
      !function (e, t, n, r) {
        var o = !n;
        n = n || {};

        for (var i = -1, a = t.length; ++i < a;) {
          var c = t[i],
              u = r ? r(n[c], e[c], c, n, e) : void 0;
          void 0 === u && (u = e[c]), o ? ce(n, c, u) : ae(n, c, u);
        }
      }(t, _e(o = t) ? ie(o, !0) : function (e) {
        if (!Le(e)) return function (e) {
          var t = [];
          if (null != e) for (var n in Object(e)) {
            t.push(n);
          }
          return t;
        }(e);
        var t = he(e),
            n = [];

        for (var r in e) {
          ("constructor" != r || !t && U.call(e, r)) && n.push(r);
        }

        return n;
      }(o), e, r);
    }, se(function (e, t) {
      var n = -1,
          r = t.length,
          o = 1 < r ? t[r - 1] : void 0,
          i = 2 < r ? t[2] : void 0;

      for (o = 3 < Pe.length && "function" == typeof o ? (r--, o) : void 0, i && ve(t[0], t[1], i) && (o = r < 3 ? void 0 : o, r = 1), e = Object(e); ++n < r;) {
        var a = t[n];
        a && Pe(e, a, 0, o);
      }

      return e;
    })),
        Ie,
        Me = se(function (e, t) {
      try {
        return I(e, void 0, t);
      } catch (e) {
        return Ae(e) ? e : new Error(e);
      }
    });

    function Fe(e) {
      return e;
    }

    We.exports = function (a, e, t) {
      var n,
          r = Re.imports._.templateSettings || Re;
      t && ve(a, e, t) && (e = void 0), a = null == (n = a) ? "" : fe(n), e = He({}, e, r, de);
      var o,
          c,
          u,
          i = He({}, e.imports, r.imports, de),
          l = _e(g = i) ? ie(g) : function (e) {
        if (!he(e)) return ee(e);
        var t = [];

        for (var n in Object(e)) {
          U.call(e, n) && "constructor" != n && t.push(n);
        }

        return t;
      }(g),
          s = (o = i, M(l, function (e) {
        return o[e];
      })),
          f = 0,
          d = e.interpolate || _,
          p = "__p += '",
          v = RegExp((e.escape || _).source + "|" + d.source + "|" + (d === De ? O : _).source + "|" + (e.evaluate || _).source + "|$", "g"),
          h = U.call(e, "sourceURL") ? "//# sourceURL=" + (e.sourceURL + "").replace(/[\r\n]/g, " ") + "\n" : "",
          g;
      a.replace(v, function (e, t, n, r, o, i) {
        return n = n || r, p += a.slice(f, i).replace(S, F), t && (c = !0, p += "' +\n__e(" + t + ") +\n'"), o && (u = !0, p += "';\n" + o + ";\n__p += '"), n && (p += "' +\n((__t = (" + n + ")) == null ? '' : __t) +\n'"), f = i + e.length, e;
      }), p += "';\n";
      var y = U.call(e, "variable") && e.variable;
      y || (p = "with (obj) {\n" + p + "\n}\n"), p = (u ? p.replace(m, "") : p).replace(j, "$1").replace(w, "$1;"), p = "function(" + (y || "obj") + ") {\n" + (y ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (c ? ", __e = _.escape" : "") + (u ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + p + "return __p\n}";
      var b = Me(function () {
        return Function(l, h + "return " + p).apply(void 0, s);
      });
      if (b.source = p, Ae(b)) throw b;
      return b;
    };
  }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}), We = We.exports;
  var T = {};
  Object.defineProperty(T, "__esModule", {
    value: !0
  }), T.restoreOriginalFootnotes = function () {
    Array.from(document.querySelectorAll("." + H)).forEach(function (e) {
      return e.classList.remove(H);
    });
  }, T.createDocumentFootnotes = function (e) {
    var t,
        n,
        r,
        o,
        i,
        a,
        c,
        u,
        l,
        s,
        f,
        d = e.buttonTemplate,
        p = e.contentTemplate,
        v = e.numberResetSelector,
        h = (n = (t = document.querySelectorAll(j.FOOTNOTE_SELECTOR)).length ? t[t.length - 1].dataset.footnoteId : "0", 1 + parseInt(n, 10)),
        g,
        y,
        b,
        m;
    return (l = (u = e).anchorPattern, f = void 0 === (s = u.scope) ? "" : s, Array.from(document.querySelectorAll(f + ' a[href^="#"]')).filter(function (e) {
      return (e.href + e.rel).match(l);
    })).map((o = (r = e).allowDuplicates, i = r.anchorParentSelector, a = r.footnoteSelector, c = [], function (e) {
      var t = "#" + e.href.split("#")[1].replace(/[:.+~*[\]]/g, "\\$&"),
          n = Array.from(document.querySelectorAll(t)).find(function (e) {
        return o || !c.includes(e);
      }),
          r = n && n.closest(a);
      if (r) return c.push(r), [e.closest(i) || e, r];
    })).filter(F).map(k).map(W(h)).map(v ? R(v) : function (e) {
      return e;
    }).map((g = d, y = p, b = (0, C.default)(g), m = (0, C.default)(y), function (e, t) {
      var n = (0, P.default)(e, 3),
          r = n[0],
          o = n[1],
          i = n[2],
          a = "".concat(t + 1),
          c = {
        number: i,
        id: a,
        content: D(o.innerHTML, r.id),
        reference: r.id
      },
          u = m(c);
      r.insertAdjacentHTML("beforebegin", '<span class="'.concat(I, '">').concat(b(c), "</span>"));
      var l = r.previousElementSibling,
          s = l.firstElementChild;
      return s.dataset.footnoteButton = "", s.dataset.footnoteId = a, s.dataset.footnoteNumber = "".concat(i), {
        id: a,
        button: s,
        host: l,
        content: u,
        isHovered: !1,
        maxHeight: 0
      };
    }));
  };

  var P = e(function (e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = [],
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          r || null == c.return || c.return();
        } finally {
          if (o) throw i;
        }
      }

      return n;
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }),
      C = e(We),
      H = "footnote-print-only",
      I = "littlefoot-footnote__host",
      M = function M(e) {
    return e.classList.add(H);
  };

  function F(e) {
    return void 0 !== e;
  }

  function D(e, t) {
    var n = t.trim().replace(/\s+/g, "|"),
        r = new RegExp("(\\s|&nbsp;)*<\\s*a[^#<]*#(" + n + ")[^>]*>(.*?)<\\s*/\\s*a>", "g"),
        o = e.trim().replace(r, "").replace("[]", "");
    return o.startsWith("<") ? o : "<p>" + o + "</p>";
  }

  var R = function R(u) {
    return function (e, t, n) {
      var r = (0, P.default)(e, 3),
          o = r[0],
          i = r[1],
          a = r[2],
          c = a ? n[a - 1][2] : 0;
      return [o, i, o.closest(u) ? 1 : c + 1];
    };
  },
      W = function W(r) {
    return function (e, t) {
      var n = (0, P.default)(e, 2);
      return [n[0], n[1], r + t];
    };
  };

  function k(e) {
    var t = (0, P.default)(e, 2),
        n = t[0],
        r = t[1];
    return M(n), M(r), function e(t) {
      var n,
          r,
          o = (n = t, r = ":not(.".concat(H, ")"), Array.from(n.children).filter(function (e) {
        return 8 !== e.nodeType && (!r || e.matches(r));
      })),
          i = o.filter(function (e) {
        return "HR" === e.tagName;
      });
      o.length === i.length && (i.concat(t).forEach(M), e(t.parentNode));
    }(r.parentElement), [n, r];
  }

  var N = {};
  Object.defineProperty(N, "__esModule", {
    value: !0
  }), N.createAdapter = function (e) {
    var t = (0, T.createDocumentFootnotes)(e).map(S.createFootnote);
    return {
      footnotes: function footnotes() {
        return t;
      },
      unmount: function unmount() {
        t.forEach(function (e) {
          return e.unmount();
        }), (0, T.restoreOriginalFootnotes)();
      }
    };
  };
  var $ = {};
  Object.defineProperty($, "__esModule", {
    value: !0
  }), $.littlefoot = B, $.default = void 0;
  var U = e(function (e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  });

  function q(t, e) {
    var n = Object.keys(t);
    return Object.getOwnPropertySymbols && n.push.apply(n, Object.getOwnPropertySymbols(t)), e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n;
  }

  var z = {
    activateDelay: 100,
    activateOnHover: !1,
    allowDuplicates: !0,
    allowMultiple: !1,
    anchorParentSelector: "sup",
    anchorPattern: /(fn|footnote|note)[:\-_\d]/gi,
    dismissDelay: 100,
    dismissOnUnhover: !1,
    footnoteSelector: "li",
    hoverDelay: 250,
    contentTemplate: '<aside class="littlefoot-footnote" id="fncontent:<%= id %>" alt="Footnote <%= number %>" aria-live="polite"><div class="'.concat(d.CLASS_WRAPPER, '"><div class="').concat(d.CLASS_CONTENT, '" tabindex="0"><%= content %></div></div><div class="').concat(d.CLASS_TOOLTIP, '"></div></aside>'),
    buttonTemplate: '<button class="littlefoot-footnote__button littlefoot-footnote__button__ellipsis" id="<%= reference %>" title="See Footnote <%= number %>" aria-controls="fncontent:<%= id %>" aria-expanded="false" aria-label="Footnote <%= number %>" rel="footnote"><svg viewbox="0 0 31 6" preserveAspectRatio="xMidYMid"><circle r="3" cx="3" cy="3" fill="white"></circle><circle r="3" cx="15" cy="3" fill="white"></circle><circle r="3" cx="27" cy="3" fill="white"></circle></svg></button>'
  };

  function B() {
    var e,
        n = function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? q(n, !0).forEach(function (e) {
          (0, U.default)(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : q(n).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }

      return t;
    }({}, z, {}, 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}),
        t = (0, N.createAdapter)(n),
        r = (0, i.createCore)(t, n),
        o = (0, j.addEventListeners)(r);

    return {
      activate: function activate(e) {
        var t = r.findById(e);
        t && r.activate(t);
      },
      dismiss: function dismiss(e, t) {
        var n = e && r.findById(e);
        n ? r.dismiss(n, t) : r.dismissAll(t);
      },
      unmount: function unmount() {
        o(), r.unmount();
      },
      getSetting: function getSetting(e) {
        return n[e];
      },
      updateSetting: function updateSetting(e, t) {
        n[e] = t;
      }
    };
  }

  var V = B;
  return $.default = V, $;
});